<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1">{{ tajukKad }}</p>
        </div>
        <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
          <el-form-item label="Kategori Permohonan" required>
            <el-input
              ref="kategoriPermohonan"
              class="el-input-size"
              v-model="registerForm.kategoriPermohonan"
              @input="()=>autoCapitalise('kategoriPermohonan')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Nama Syarikat" required>
            <el-input
              ref="namaSyarikat"
              class="el-input-size"
              v-model="registerForm.namaSyarikat"
              @input="()=>autoCapitalise('namaSyarikat')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. Pendaftaran Syarikat / No. Kad Pengenalan / No. PBT" required>
            <el-input
              ref="noPendaftaranSyarikat"
              class="el-input-size"
              v-model="registerForm.noPendaftaranSyarikat"
              @input="()=>autoCapitalise('noPendaftaranSyarikat')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. SSM Baru" required>
            <el-input
              ref="noSSMBaru"
              class="el-input-size"
              v-model="registerForm.noSSMBaru"
              @input="()=>autoCapitalise('noSSMBaru')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Alamat" required>
            <el-input
              ref="alamat1"
              class="el-input-size"
              v-model="registerForm.alamat1"
              @input="()=>autoCapitalise('alamat1')"
              disabled>
            </el-input>
            <el-input
              ref="alamat2"
              class="el-input-size"
              v-model="registerForm.alamat2"
              @input="()=>autoCapitalise('alamat2')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Poskod" required>
            <el-input
              ref="poskod"
              class="el-input-size"
              v-model="registerForm.poskod"
              @input="()=>autoCapitalise('poskod')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Negeri" required>
            <el-select
              ref="negeri"
              class="el-input-size"
              v-model="registerForm.negeri"
              disabled>
              <el-option label="--- Sila Pilih ---" value=""></el-option>
              <el-option
                v-for="state in stateList"
                :key="state"
                :label="state"
                :value="state">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Daerah" required>
            <el-select
              ref="daerah"
              class="el-input-size"
              v-model="registerForm.daerah"
              @input="()=>autoCapitalise('daerah')"
              disabled>
              <el-option label="--- Sila Pilih ---" value=""></el-option>
              <el-option
                v-for="district in districtList"
                :key="district"
                :label="district"
                :value="district">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="No. Telefon Pejabat">
            <el-input
              ref="noTelefonPejabat"
              class="el-input-size"
              v-model="registerForm.noTelefonPejabat"
              @input="()=>autoCapitalise('noTelefonPejabat')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. Telefon (H/P)" required>
            <el-input
              ref="noTelefon"
              class="el-input-size"
              v-model="registerForm.noTelefon"
              @input="()=>autoCapitalise('noTelefon')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. Fax">
            <el-input
              ref="noFax"
              class="el-input-size"
              v-model="registerForm.noFax"
              @input="()=>autoCapitalise('noFax')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Emel" required>
            <el-input
              ref="emel"
              class="el-input-size"
              v-model="registerForm.emel"
              @input="()=>autoCapitalise('emel')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Nama Wakil" required>
            <el-input
              ref="namaWakil"
              class="el-input-size"
              v-model="registerForm.namaWakil"
              @input="()=>autoCapitalise('namaWakil')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. Kad Pengenalan Wakil Syarikat" required>
            <el-input
              ref="noKadPengenalanWakilSyarikat"
              class="el-input-size"
              v-model="registerForm.noKadPengenalanWakilSyarikat"
              @input="()=>autoCapitalise('noKadPengenalanWakilSyarikat')"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Jawatan Wakil Syarikat" required>
            <el-input
              ref="jawatanWakilSyarikat"
              class="el-input-size"
              v-model="registerForm.jawatanWakilSyarikat"
              @input="()=>autoCapitalise('jawatanWakilSyarikat')"
              disabled>
            </el-input>
          </el-form-item>
          <!-- <p class="el-input-size" style="color: #cc0000">** Sila tanda jika syarikat adalah stesen minyak</p>
          <div class="el-form-item">
            <label class="el-form-item__label">
              Syarikat ini adalah Stesen Minyak
              <el-checkbox
                style="margin-left: 20px;"
                v-model="registerForm.syarikatIniAdalahStesenMinyak"
                disabled>
              </el-checkbox>
            </label>
          </div> -->
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'profil-pemohon-kad-diesel',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false,
      loading: false,
      stateList: [
        "PERAK",
        "SELANGOR",
        "PAHANG",
        "KELANTAN",
        "JOHOR",
        "KEDAH",
        "WILAYAH PERSEKUTUAN LABUAN",
        "MELAKA",
        "NEGERI SEMBILAN",
        "PULAU PINANG",
        "SARAWAK",
        "PERLIS",
        "SABAH",
        "TERENGGANU",
        "WILAYAH PERSEKUTUAN KUALA LUMPUR",
        "WILAYAH PERSEKUTUAN PUTRAJAYA"
      ],
      districtList: [
        "KAJANG",
        "BANDAR BARU BANGI",
        "SERI KEMBANGAN",
        "KUALA LUMPUR",
        "HULU LANGAT",
        "BERANANG",
        "KAPAR",
        "PETALING JAYA",
        "BANTING",
        "SHAH ALAM",
        "SELAYANG",
        "GOMBAK",
        "AMPANG",
        "KLANG",
        "SUBANG",
        "SUNGAI BULOH",
        "KEPONG",
        "CHERAS",
        "BANGI",
        "BATU CAVES",
        "SUBANG JAYA",
        "SUNGAI BESAR",
        "BATANG BERJUNTAI",
        "BUKIT ROTAN",
        "KERLING",
        "KUALA KUBU BHARU",
        "HULU KELANG",
        "SEPANG",
        "SEMENYIH",
        "PUCHONG",
        "RAWANG",
        "KELANA JAYA",
        "SEKINCHAN",
        "SENTUL",
        "TANJUNG MALIM",
        "PELABUHAN KLANG",
        "SRI DAMANSARA ",
        "DENGKIL",
        "DAMANSARA HEIGHTS",
        "PUNCAK ALAM",
        "SERENDAH",
        "JERAM",
        "UPM",
        "PUTRA PERMAI",
        "SG. PELEK",
        "BALAKONG",
        "ULU SELANGOR ",
        "SIMUNJAN",
        "BANDAR DAMANSARA",
        "KOTA DAMANSARA",
        "KLUANG",
        "AMPANG JAYA",
        "TELUK PANGLIMA GARANG",
        "SABAK BERNAM",
        "TUN RAZAK",
        "SETAPAK",
        "KUALA LANGAT",
        "BUKIT DAMANSARA",
        "KUALA SELANGOR",
        "BATANG KALI",
        "KLIA",
        "PRIMA DAMANSARA",
        "HULU SELANGOR",
        "SALAK TINGGI",
        "DAMANSARA UTAMA",
        "ULU KLANG",
        "GOMBAK UTARA",
        "PULAU INDAH",
        "PETALING",
        "UEP SUBANG JAYA",
        "TAMAN KERAMAT",
        "KALUMPANG",
        "TANJUNG SEPAT",
        "TAIPAN TRIANGLE",
        "KUANG",
        "BANDAR SRI DAMANSARA",
        "SRI GOMBAK",
        "DAMANSARA PERDANA",
        "SERDANG",
        "TANJONG KARANG"
      ],
      locked: false
    }
  },
  methods: {
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    }
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    registerForm: {
      type: Object
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/mydiesel/components/ProfilPemohonKadDiesel.vue